import gsap from 'gsap'
import axios from 'axios'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)
export default function service(){

  document.querySelectorAll('.serviceListContentModal').forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault() // ページ遷移を防止

      let modalOverlay = document.createElement('div')
      modalOverlay.classList.add('modal-overlay')
      document.body.appendChild(modalOverlay)

      let apiUrl = this.getAttribute('data-url')

      axios.get(apiUrl)
        .then(function(response) {
          let modalContent = document.createElement('div')
          modalContent.classList.add('modal-content')

          let modalContentInner = document.createElement('div')
          modalContentInner.classList.add('modal-content-inner')
          modalContentInner.classList.add('modal-content-inner--service')


          // Grid要素の追加
          let gridElem = document.createElement('div')
          gridElem.classList.add('modal-content-grid')

          // 画像を追加
          let imgElement = document.createElement('img')
          imgElement.src = response.data._embedded['wp:featuredmedia'][0].source_url
          gridElem.appendChild(imgElement)

          // タイトルを追加
          let divElem = document.createElement('div')
          divElem.classList.add('modal-content-grid--item')

          let titleElement = document.createElement('h2')
          titleElement.textContent = response.data.title.rendered
          divElem.appendChild(titleElement)

          let descElement = document.createElement('div')
          descElement.innerHTML = response.data.acf.overview
          divElem.appendChild(descElement)

          gridElem.appendChild(divElem)
          modalContentInner.appendChild(gridElem)

          // リストを追加

          let listTitle = document.createElement('h3')
          listTitle.classList.add('servicelist-title')
          listTitle.textContent = 'サービス内容'
          modalContentInner.appendChild(listTitle)

          let listItem = document.createElement('ul')
          listItem.classList.add('servicelist')

          let listData = response.data.acf.explanation
          listData.forEach((el) => {
            let li = document.createElement('li')
            li.innerHTML = el.item
            listItem.appendChild(li)
          })
          modalContentInner.appendChild(listItem)
          

          let closeButton = document.createElement('div')
          closeButton.classList.add('modal-content-btn')
          closeButton.textContent = '×'
          closeButton.addEventListener('click', function() {
            modalOverlay.remove()
          })

          modalContent.appendChild(closeButton)
          modalContent.appendChild(modalContentInner)
          modalOverlay.appendChild(modalContent)
        })
        .catch(function(error) {
          console.error('Error fetching modal content:', error)
        })
    })
  })
 
}